export * from '@primeuix/themes/lara/inputotp';
export { default } from '@primeuix/themes/lara/inputotp';
